import React, { useState, useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import dayjs from "dayjs";
import AssetsSuggestions from "./AssetSuggestion";
import currentUserToken from "CurrentUserToken";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import { tlmGetWorkType } from "layouts/dashboard/apiService";
import WorkOrderSuggestions from "./WorkOrderSuggestion";

const numericRule = /^(?:[0-9]{1,10}(?:\.[0-9]{1,6})?)?$/m;

function SalesForceStep(props) {
  // const { billingCode } = props;
  const [auditData, setAuditData] = useState({ audit: [], fetched: false });
  const [salesOrgFetched, setSalesOrgFetched] = useState(false);
  const [assetNumericError, setAssetNumericError] = useState(null);
  const [assetFocused, setAssetFocused] = useState(false);
  const [showAssetsSuggestion, setShowAssetsSuggestion] = useState(false);
  const [showWorkOrderSuggestion, setShowWorkOrderSuggestion] = useState(false);
  const [workOrderData, setWorkOrderData] = useState([]);

  useEffect(() => {
    const tlmGetAccountAssets = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/accountNumber/asset",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {
              account_id: props.mainFormData.account_id,
            },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        if (Array.isArray(response)) {
          response.forEach((element) => {
            if (typeof element.timestamp === "number") {
              element.timestamp = dayjs(element.timestamp).format(
                "YYYY-MM-DD HH:mm"
              );
            }
          });
          setAuditData({ audit: response, fetched: true });
        }
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    };

    tlmGetAccountAssets();
  }, []);
  const [switchDisabled, setSwitchDisabled] = useState(true);
  useEffect(() => {
    setSwitchDisabled(true);

    const tlmGetSalesOrganization = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/salesOrganization/get",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {
              account_number: props.mainFormData.account_number,
            },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        const salesOrg = response?.data?.[0]?.external_id__c;
        if (salesOrg) {
          props.handleMainFormData("salesorganization", salesOrg);
          setSalesOrgFetched(true);
        }

        try {
          const responseData = await tlmGetWorkType(
            response.data[0].fsl_countrycode__c
          );
          setWorkOrderData(responseData);
        } catch (error) {
          console.log(error);
        }
        setSwitchDisabled(false);
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    };
    tlmGetSalesOrganization();
  }, [props.mainFormData.account_number]);

  const checkAssetNumeric = (newInput) => {
    if (!numericRule.test(newInput) && props.mainFormData["asset"] !== null) {
      setAssetNumericError(
        "Field must be a numeric value with up to 10 whole digits"
      );
    } else {
      setAssetNumericError(null);
    }
  };

  const handleChange = (event) => {
    props.handleMainFormData(event.target.name, event.target.value);
  };

  const handleSwitchChange = (event) => {
    props.handleMainFormData("toBeBundled", event.target.checked);
  };
  const handleSwitchChange2 = (event) => {
    props.handleMainFormData("createWorkOrder", event.target.checked);
  };

  const setAsset = (newAsset) => {
    props.handleMainFormData("asset", newAsset);
  };

  const setWorkOrder = (newWorkOrder) => {
    props.handleMainFormData("work_order", newWorkOrder);
  };

  useEffect(() => {
    checkAssetNumeric(props.mainFormData["asset"]);
  }, [props.mainFormData["asset"]]);

  return (
    <>
      <DialogContent>
        <FormControl fullWidth margin="normal" className="custom-form-control">
          <InputLabel>{I18n.get("Case Origin")}</InputLabel>
          <Select
            value={props.mainFormData.caseorigin}
            onChange={handleChange}
            name="caseorigin"
            label={I18n.get("Case Origin")}
          >
            <MenuItem value="Telemonitoring">
              {I18n.get("Telemonitoring")}
            </MenuItem>
          </Select>
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              margin="normal"
              className="custom-form-control"
            >
              <InputLabel className="custom-input-label">
                {I18n.get("Type")}
              </InputLabel>
              <Select
                value={props.mainFormData.type}
                onChange={handleChange}
                name="type"
                label={I18n.get("Type")}
              >
                <MenuItem value="Service Call">
                  {I18n.get("Service Call")}
                </MenuItem>
              </Select>
              <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              margin="normal"
              className="custom-form-control"
            >
              <InputLabel className="custom-input-label">
                {I18n.get("Subtype")}
              </InputLabel>
              <Select
                value={props.mainFormData.subtype}
                onChange={handleChange}
                name="subtype"
                label={I18n.get("Subtype")}
              >
                <MenuItem value="Functional">{I18n.get("Functional")}</MenuItem>
              </Select>
              <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Subject")}
            value={props.mainFormData.subject || ""}
            onChange={handleChange}
            fullWidth
            margin="normal"
            name="subject"
            required
            className="custom-text-field"
            error={props.mainFormData.subject.length > 40}
            helperText={
              props.mainFormData.subject.length > 40
                ? I18n.get("Subject length must be less than 40 characters")
                : I18n.get("Mandatory field")
            }
          />
        </FormControl>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              margin="normal"
              className="custom-form-control"
            >
              <TextField
                label={I18n.get("Account number")}
                value={props.mainFormData.account_number}
                fullWidth
                margin="normal"
                name="account_number"
                InputProps={{
                  readOnly: true,
                }}
                required
                disabled
                className="custom-text-field"
              />
              <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              margin="normal"
              className="custom-form-control"
            >
              <TextField
                label={I18n.get("Asset")}
                value={props.mainFormData.asset || ""}
                onChange={handleChange}
                fullWidth
                margin="normal"
                name="asset"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SettingsSuggestIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowAssetsSuggestion(true)}
                      />
                    </InputAdornment>
                  ),
                }}
                error={assetFocused && Boolean(assetNumericError)}
                onFocus={() => setAssetFocused(true)}
                onBlur={() => setAssetFocused(false)}
                helperText={
                  assetNumericError
                    ? assetNumericError
                    : I18n.get("Mandatory field")
                }
              />
            </FormControl>
          </Grid>
        </Grid>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Description")}
            value={props.mainFormData.description}
            onChange={handleChange}
            fullWidth
            margin="normal"
            name="description"
            required
            multiline
            rows={4}
          />
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>

        <Grid item>
          <FormControlLabel
            control={
              <Switch
                id="tobebundled-switch"
                checked={props.mainFormData.toBeBundled}
                onChange={handleSwitchChange}
                name="toBeBundled"
              />
            }
            label={I18n.get("To be Bundled")}
          />
        </Grid>
        <Grid item>
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </Grid>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Sales Organization (Es EP40_30_10)")}
            disabled
            value={
              salesOrgFetched
                ? props.mainFormData.salesorganization
                : I18n.get("Loading...")
            }
            fullWidth
            margin="normal"
            name="salesorganization"
            required
            className="custom-text-field"
          />
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>
        <FormControl fullWidth margin="normal" className="custom-form-control">
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  id="createWorkOrder-switch"
                  checked={props.mainFormData.createWorkOrder}
                  onChange={handleSwitchChange2}
                  name="createWorkOrder"
                  disabled={switchDisabled}
                />
              }
              label={I18n.get("Create work order")}
            />
          </Grid>
          {props.mainFormData.createWorkOrder && (
            <Grid item>
              <TextField
                label={I18n.get("Work order")}
                value={props.mainFormData.work_order || ""}
                onChange={handleChange}
                fullWidth
                margin="normal"
                name="work_order"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SettingsSuggestIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowWorkOrderSuggestion(true)}
                      />
                    </InputAdornment>
                  ),
                }}
                // error={assetFocused && Boolean(assetNumericError)}
                // onFocus={() => setAssetFocused(true)}
                // onBlur={() => setAssetFocused(false)}
              />
            </Grid>
          )}
        </FormControl>
      </DialogContent>
      <AssetsSuggestions
        open={showAssetsSuggestion}
        onClose={() => setShowAssetsSuggestion(false)}
        state={auditData}
        setAsset={setAsset}
      />
      <WorkOrderSuggestions
        open={showWorkOrderSuggestion}
        onClose={() => setShowWorkOrderSuggestion(false)}
        data={workOrderData}
        setWorkOrder={setWorkOrder}
      />
    </>
  );
}

export default SalesForceStep;
